// extracted by mini-css-extract-plugin
export var black = "_4j-6";
export var brand = "_4j-1";
export var ddefault = "_4j-0";
export var error = "_4j-3";
export var gray = "_4j-2";
export var highContrast = "_4j-8";
export var outline = "_4j-7";
export var success = "_4j-5";
export var warning = "_4j-4";